// deno-fmt-ignore-file
export function FromLiteral(value) {
    const result = [`${value}`];
    return result;
}
